import React from "react"

import SEO from "components/seo"

const PdfPage = () => {
  const DOCUMENT = "https://api-kivis.gmd.lt/documents/GMD25_Map.pdf"
  const VIEWER = `https://drive.google.com/viewerng/viewer?embedded=true&url=${DOCUMENT}`

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <SEO title="Vilnius.pdf" />
      <iframe title="Vilnius.pdf" src={VIEWER} width="100%" height="100%" />
    </div>
  )
}

export default PdfPage
